import React from 'react';
import {
    Button, Row, Col, Spinner,
} from 'reactstrap';
import { getShort } from '@s20/common/util/date';
import { Can } from '../Can';
import { SmallButton } from '../common/forms/FormElements';
import CommonContext from '../Common';


const formatPayRate = (value) => {
    const formatted = parseFloat(value).toFixed(4);
    const trimmed = formatted.replace(/(\.\d{2}[1-9]?)0+$/, '$1');
    return trimmed;
};

export class EmployeePayRateInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
        };
    }

    componentDidMount() {
        this.populateState();
    }

    populateState() {
        this.setState({
            loading: false,
        });
    }

    render() {
        const { loading } = this.state;
        const { payRates, onAddPayRate, onEditPayRate } = this.props;

        if (loading) {
            return (
                <Spinner />
            );
        }
        return (
            <>
                <Row className="pb-1">
                    <Col>
                        <div className="d-flex flex-row align-items-center justify-content-end">
                            <Can
                                I="edit"
                                a="employee"
                            >
                                <CommonContext.Consumer>
                                    {(context) => (
                                        <SmallButton
                                            disabled={!!context.formIsOpen}
                                            type="button"
                                            onClick={onAddPayRate}
                                        >
                                            <i className="fa fa-plus-circle fa-md mr-2" />
                                            Add Pay Rate
                                        </SmallButton>
                                    )}
                                </CommonContext.Consumer>
                            </Can>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <table className="table table-sm table-bordered">
                            <thead className="text-muted">
                                <tr>
                                    <th>Pay Rate</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Rate Received</th>
                                    <Can
                                        I="edit"
                                        a="employee"
                                    >
                                        <th
                                            className="text-center"
                                            style={{ width: '30px' }}
                                        />
                                    </Can>
                                </tr>
                            </thead>
                            <tbody>
                                {!(payRates ?? []).length ? (
                                    <tr>
                                        <td
                                            colSpan="5"
                                            className="text-center"
                                        >
                                            No rates found.
                                        </td>
                                    </tr>
                                ) : (
                                    payRates.map((rateInfo) => {
                                        let endDate = '';

                                        if (rateInfo.endDate != null && rateInfo.endDate.trim() !== '') {
                                            endDate = getShort(rateInfo.endDate);
                                        } else if (rateInfo.endDate == '' || rateInfo.endDate == null) {
                                            endDate = 'Current';
                                        }

                                        return (
                                            <tr key={rateInfo.id}>
                                                <td>
                                                    {formatPayRate(rateInfo.payRate)}
                                                </td>
                                                <td>
                                                    {getShort(
                                                        rateInfo.startDate,
                                                    )}
                                                </td>
                                                <td>
                                                    {
                                                        endDate
                                                    }
                                                </td>
                                                <td>
                                                    {getShort(
                                                        rateInfo.rateReceivedDate,
                                                    )}
                                                </td>
                                                <Can
                                                    I="edit"
                                                    a="employee"
                                                >
                                                    <CommonContext.Consumer>
                                                        {(context) => (
                                                            <td>
                                                                <Button
                                                                    disabled={
                                                                        !!context.formIsOpen
                                                                    }
                                                                    type="button"
                                                                    color="outline-primary"
                                                                    onClick={() => onEditPayRate(
                                                                        rateInfo,
                                                                    )}
                                                                    size="sm"
                                                                >
                                                                    Edit
                                                                </Button>
                                                            </td>
                                                        )}
                                                    </CommonContext.Consumer>
                                                </Can>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </>
        );
    }
}

EmployeePayRateInfo.contextType = CommonContext;
